module.exports = __webpack_public_path__ + "img/more-data-table.efbaa9bc.svg";